<template>
  <h2>User Profile Edit</h2>
  <form>
    <div class="form-control" :class="{ invalid: !newUserName.isValid }">
      <label for="username">Username</label>
      <div>
        <input
          type="text"
          id="username"
          v-model.trim="newUserName.val"
          @blur="clearValidity('newUserName')"
        />
      </div>
      <p v-if="!newUserName.isValid">
        {{
          newUserName.val === ""
            ? "Username must not be empty."
            : "Username must not contain spaces."
        }}
      </p>
    </div>
    <div class="form-control" :class="{ invalid: !newEmail.isValid }">
      <label for="email">Email Address</label>
      <div>
        <span class="material-icons"> email </span>
        <input
          type="email"
          id="email"
          v-model.trim="newEmail.val"
          @blur="clearValidity('newEmail')"
        />
      </div>
      <p v-if="!newEmail.isValid">Please provide a valid email address.</p>
    </div>
    <p v-if="!formIsValid">Please fix the above errors and submit again.</p>
    <base-button @click.prevent="cancelForm">Cancel</base-button>
    <base-button @click.prevent="submitForm">Save</base-button>
  </form>
</template>

<script>
export default {
  emits: ["save-data", "cancel"],
  computed: {
    userName() {
      return this.$store.getters.currentUser.userName;
    },
    email() {
      return this.$store.getters.currentUser.email;
    },
  },
  data() {
    return {
      newUserName: {
        val: "",
        isValid: true,
      },
      newEmail: {
        val: "",
        isValid: true,
      },
      formIsValid: true,
      errMessage: "",
    };
  },
  mounted() {
    this.newUserName.val = this.userName;
    this.newEmail.val = this.email;
  },
  props: ["id"],
  methods: {
    clearValidity(input) {
      this[input].isValid = true;
    },
    validateForm() {
      this.formIsValid = true;
      if (
        this.newUserName.val === "" ||
        !this.validUserName(this.newUserName.val)
      ) {
        this.newUserName.isValid = false;
        this.formIsValid = false;
      }
      if (this.newEmail.val === "" || !this.validEmail(this.newEmail.val)) {
        this.newEmail.isValid = false;
        this.formIsValid = false;
      }
    },
    validUserName(name) {
      const reg = /^[^ ]+$/;

      // Explanation:
      // at the beginning of the string, 1 or more characters not including <>()[]\.,;:@ or a space
      // followed by a dot (.) followed by 1 or more characters not including the same as above (0 or more times) or any character 1 or more times
      // followed by an '@'
      // (needs more work...)
      return reg.test(name);
    },
    validEmail(email) {
      const reg =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;

      // Explanation:
      // at the beginning of the string, 1 or more characters not including <>()[]\.,;:@ or a space
      // followed by a dot (.) followed by 1 or more characters not including the same as above (0 or more times) or any character 1 or more times
      // followed by an '@'
      // (needs more work...)
      return reg.test(email);
    },
    cancelForm() {
      this.$emit("cancel");
    },
    submitForm() {
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      const formData = {
        userName: this.newUserName.val,
        email: this.newEmail.val,
      };

      this.$emit("save-data", formData);
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  display: block;
  margin-bottom: 0.5rem;
}

input[type="checkbox"] + label {
  font-weight: normal;
  display: inline;
  margin: 0 0 0 0.5rem;
}

input,
textarea {
  display: block;
  width: 100%;
  border: 1px solid #ccc;
  font: inherit;
}

input:focus,
textarea:focus {
  background-color: #f0e6fd;
  outline: none;
  border-color: #3d008d;
}

input[type="checkbox"] {
  display: inline;
  width: auto;
  border: none;
}

input[type="checkbox"]:focus {
  outline: #3d008d solid 1px;
}

h3 {
  margin: 0.5rem 0;
  font-size: 1rem;
}

.invalid label {
  color: red;
}

.invalid input,
.invalid textarea {
  border: 1px solid red;
}

.form-control {
  display: block;
  margin: 0.5rem 0;
  width: 100%;
  /* height: 34px; */
  padding: 6px 12px;
  font-size: 14px;
  color: #555;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
}
</style>